/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AccountCircleIcon from 'material-ui-icons/AccountCircle'
import Divider from 'material-ui/Divider'
import Drawer from 'material-ui/Drawer'
import GroupIcon from 'material-ui-icons/Group'
import { hasAuthorization, hasMembership, hasRole } from '../utils/helpers';
import KeyIcon from 'material-ui-icons/VpnKey'
import List from 'material-ui/List'
import { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import LockIcon from 'material-ui-icons/Lock'
import Messages from '../constants/messages'
import OpenInNewIcon from 'material-ui-icons/OpenInNew'
import { nordAdmins, partnerAccessAdmin, partnerAccessAll, sysAdmin } from '../constants/memberships';
import SettingsIcon from 'material-ui-icons/Settings'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  appName: PropTypes.string,
  appUrl: PropTypes.string,
  classes: PropTypes.object.isRequired,
  changePage: PropTypes.func.isRequired,
  userMemberships: PropTypes.array.isRequired,
  userRoles: PropTypes.array.isRequired,
  version: PropTypes.string.isRequired
}

const drawerWidth = 240

const styles = theme => ({
  root: {
    background: 'white'
  },
  copyright: {
    display: 'inline-block',
    width: '50%',
    textAlign: 'left'
  },
  drawer: {
    height: '100%'
  },
  drawerPaper: {
    position: 'relative',
    height: '100%',
    width: drawerWidth
  },
  drawerHeader: {
    textAlign: 'center',
    padding: 20,
    height: 26,
    [theme.breakpoints.up('sm')]: {
      height: 23,
    },
  },
  footer: {
    padding: 10,
    fontSize: 10
  },
  listContainer: {
    height: '-webkit-fill-available'
  },
  nordstromLogo: {
    width: '95%'
  },
  profileDivider: {
    margin: '7px 0'
  },
  version: {
    display: 'inline-block',
    width: '50%',
    textAlign: 'right'
  }
})

export class SideNavigation extends Component {

  handleNavItemClick(route, heading) {
    const { changePage } = this.props

    changePage(route)
  }

  shouldShowUsers() {
    const { userMemberships, userRoles } = this.props
    return hasAuthorization(userMemberships, userRoles, nordAdmins, partnerAccessAdmin)
  }

  shouldShowGroups() {
    const { userMemberships, userRoles } = this.props
    return hasAuthorization(userMemberships, userRoles, nordAdmins, partnerAccessAdmin)
  }

  shouldShowRoles() {
    const { userMemberships } = this.props
    return hasMembership(userMemberships, sysAdmin)
  }

  shouldShowPermissions() {
    const { userMemberships } = this.props
    return hasMembership(userMemberships, sysAdmin)
  }

  shouldShowProfile() {
    const { userRoles } = this.props
    return hasRole(userRoles, partnerAccessAdmin)
  }

  shouldShowAppLink() {
    const { appUrl, userMemberships, userRoles } = this.props
    return appUrl && (hasMembership(userMemberships, nordAdmins) || hasRole(userRoles, partnerAccessAll))
  }

  renderUsers() {
    return (
      <ListItem data-test-id="users-list-item" button onClick={() => this.handleNavItemClick('/users', 'Users')}>
        <ListItemIcon>
          <AccountCircleIcon />
        </ListItemIcon>
        <ListItemText primary={Messages['uiComponents']['SIDE_NAV_USERS']} />
      </ListItem>
    )
  }

  renderGroups() {
    return (
      <ListItem data-test-id="groups-list-item" button onClick={() => this.handleNavItemClick('/groups', 'Groups')}>
        <ListItemIcon>
          <GroupIcon />
        </ListItemIcon>
        <ListItemText primary={Messages['uiComponents']['SIDE_NAV_GROUPS']} />
      </ListItem>
    )
  }

  renderPermissions() {
    return (
      <ListItem data-test-id="permissions-list-item" button onClick={() => this.handleNavItemClick('/permissions', 'Permissions')}>
        <ListItemIcon>
          <LockIcon />
        </ListItemIcon>
        <ListItemText primary={Messages['uiComponents']['SIDE_NAV_PERMISSIONS']} />
      </ListItem>
    )
  }

  renderRoles() {
    return (
      <ListItem data-test-id="roles-list-item" button onClick={() => this.handleNavItemClick('/roles', 'Roles')}>
        <ListItemIcon>
          <KeyIcon />
        </ListItemIcon>
        <ListItemText primary={Messages['uiComponents']['SIDE_NAV_ROLES']} />
      </ListItem>
    )
  }

  renderDivider() {
    const { classes } = this.props
    return <Divider data-test-id="divider-side-nav" className={classes.profileDivider} />
  }

  renderProfile() {
    return (
      <div>
        <ListItem data-test-id="profile-list-item" button onClick={() => this.handleNavItemClick('/profile', 'Profile')}>
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary={Messages['uiComponents']['SIDE_NAV_PROFILE']} />
        </ListItem>
      </div>
    )
  }

  renderAppLink() {
    const { appName, appUrl } = this.props
    return (
      <div>
        <ListItem data-test-id="applink-list-item" button component="a" href={appUrl} target="_blank">
          <ListItemIcon>
            <OpenInNewIcon />
          </ListItemIcon>
          <ListItemText primary={appName} />
        </ListItem>
      </div>
    )
  }

  renderNavLinks() {
    // cache results (necessary to determine whether to show divider)
    const showUsers = this.shouldShowUsers()
    const showGroups = this.shouldShowGroups()
    const showRoles = this.shouldShowRoles()
    const showPermissions = this.shouldShowPermissions()
    const showProfile = this.shouldShowProfile()
    const showAppLink = this.shouldShowAppLink()
    const showDivider = (showUsers || showGroups || showRoles || showPermissions) && (showProfile || showAppLink)
    return (
      <div>
        {showUsers ? this.renderUsers() : null}
        {showGroups ? this.renderGroups() : null}
        <div>
          {showRoles ? this.renderRoles() : null}
          {showPermissions ? this.renderPermissions() : null}
        </div>
        {showDivider ? this.renderDivider() : null}
        {showProfile ? this.renderProfile() : null}
        {showAppLink ? this.renderAppLink() : null}
      </div>
    )
  }

  render() {
    const { classes, version } = this.props
    return (
      <nav className={classes.root}>
        <Drawer
          type="permanent"
          className={classes.drawer}
          classes={{
            paper: classes.drawerPaper,
          }} >
          <div className={classes.drawerHeader}>
            <img
              data-test-id="nordstrom-logo"
              src="https://s3-us-west-2.amazonaws.com/nauth-prod/Design+Assets/nord_logo/nord_logo_black%402x.png"
              className={classes.nordstromLogo}
              alt="nordstrom logo" />
          </div>
          <Divider />
          <List className={classes.listContainer}>
            { this.renderNavLinks() }
          </List>
          <Divider />
          <div className={classes.footer}>
            <span className={classes.copyright}>&copy; {`${(new Date()).getFullYear()} Nordstrom, Inc.`}</span>
            <span className={classes.version}>v{version}</span>
          </div>
        </Drawer>
      </nav>
    )
  }
}

SideNavigation.propTypes = PROP_TYPES

export default withStyles(styles)(SideNavigation)
